import {Component, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';


import {CreditService} from './credit.service';
import {CreditLimitDailyModel} from './credit-limit-daily.model';
import {FacadeSacimService} from '../../core/services/facade-sacim.service';
import {environment} from '../../core/environments/environment';

import {
	COUNTRY,
	CURRENCY_CONFIG_CODE,
	CURRENCY_CONFIG_FORMAT_DECIMAL2,
	CURRENCY_CONFIG_SYMBOL,
	DATE_CONFIG
} from '../../constants.sacim';
import { SelectItem } from 'primeng/api';



@Component({
    selector: 'credit',
    templateUrl: './credit-limit.component.html',
    styleUrls: ['./credit-limit.component.scss'],
    standalone: false
})
export class CreditLimitComponent implements OnInit {

	selectedDealerCode: bigint;
	creditLimit: CreditLimitDailyModel[];
	loading: boolean = false;

	cols: any[];
	selectStatus: SelectItem[];

	selectedDatas: Date;


	display: boolean = false;

	config_date = DATE_CONFIG;
	config_valor_decimal = CURRENCY_CONFIG_FORMAT_DECIMAL2;
	config_pais = COUNTRY;
	config_pais_code = CURRENCY_CONFIG_CODE;
	config_symbol = CURRENCY_CONFIG_SYMBOL;
	private $scope: any;

	constructor(private walletService: CreditService,
				private datePipe: DatePipe,
				private fileService: FacadeSacimService,
				private router: Router) {

	}

	ngOnInit(): void {

		if (JSON.parse(sessionStorage.getItem("role")).findIndex(item => item == environment.apsDescription + ':saldo') == -1) {
    		this.router.navigate(['/restrict']);
    	}

// 		const today = new Date();
// 		this.selectedDatas = today;

		this.cols = [
			{
				field: 'balanceDate', header: 'Data do saldo', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'data', width: '7%'
			},

			{
				field: 'dealerNo', header: 'Dealer', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'texto', width: '5%', SortableColumn: true
			},

			{
				field: 'dealerName', header: 'Nome do Dealer', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'texto', width: '10%', SortableColumn: true
			},

			{
				field: 'account', header: 'Conta', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'texto', width: '8%'
			},

			{
				field: 'valueLimitCredit', header: 'Valor do limite de credito', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'moeda', width: '13%'
			},

			{
				field: 'valueAuthorized', header: 'Valor autorizado', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'moeda', width: '10%'
			},

			{
				field: 'valueRemetidoCessa', header: 'Títulos liberadods na Cessão', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'moeda', width: '10%'
			},

			{
				field: 'valueCedidoSucess', header: 'Titulos Cedidos com Sucesso', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'moeda', width: '10%'
			},

			{
				field: 'valueCedidoReject', header: 'Titulos Cedido com Recusa', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'moeda', width: '10%'
			},

			{
				field: 'valuependent', header: 'Titulos Pendentes', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'moeda', width: '10%'
			},

			{
				field: 'datalimitCredit', header: 'Data do limite de crédito', showOnMobile: true,
				showOnMicroMobile: true, tipo: 'data', width: '15%'
			},

		];

// 		this.loadData();

	}

// 	loadData(): void {
//
// 		this.search();
//
// 	}

	exportData() {
		this.fileService.exportExcel('LimitCredit', this.creditLimit);
	}

	search() {
		this.creditLimit = [];

		if ((this.selectedDatas != null && this.selectedDatas != undefined)  ) {

			this.showDialogSpinner();

			const data = this.datePipe.transform(this.selectedDatas, 'yyyy-MM-dd');

			this.walletService.getLimitCredit(data, this.selectedDealerCode, false).subscribe(
				result => {
					if (result.length === 0) {
						this.fileService.showMessage('warn', 'Mensagem ao usuário', 'registro não encontrado');
					} else {
						this.creditLimit = result;
					}
					this.hideDialogSpinner();
				},
				() => {
					console.log('getLimitCredit ERROR!');
				},
				() => {
					console.log('getLimitCredit Completed');
				}
			);
		} else {
			this.fileService.showMessage('warn', 'Mensagem ao usuário', 'data obrigatória');
		}


	}

	onClean() {
		this.selectedDealerCode = null;
		this.selectedDatas = null;
	}


	onLoadPage(event: any) {
		this.loading = true;
		setTimeout( () => {
			if ((this.selectedDatas != null && this.selectedDatas != undefined) || this.selectedDealerCode != undefined ) {
				this.search();
			}
		}, 1000);

		this.loading = false;
	}

	showDialogSpinner(){
		this.display = true;
	}

	hideDialogSpinner(){
		this.display = false;
	}

}
